<div class="client-list-modal">
  <!-- Header -->
  <div class="client-list-modal__rectangle"></div>

  <div class="d-flex align-items-center justify-content-end mb-2 pr-4">
    <button type="button" class="client-list-modal__close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">
        <img src="../../../../assets/img/app/little-icons/cancel.svg" alt="cancel" />
      </span>
    </button>
  </div>

  <!-- Title -->
  <div class="client-list-modal__header justify-content-start mb-4">
    <h4 class="client-list-modal__title">Listado de Clientes</h4>
  </div>

  <!-- Body -->
  <div class="client-list-modal__body">
    <!-- Filtros -->
    <div class="client-list-modal__filters mb-4">
      <h5 class="client-list-modal__subtitle mb-4">Buscar cliente</h5>

      <!-- Filter Fields -->
      <div class="row mb-3" style="padding: 0px 15px;">
        <label class="col-4" style="padding: 0px 3px;">
          <div class="client-list-modal__label">Nombre</div>
          <input class="client-list-modal__select" type="text" [(ngModel)]="filterFirstName" />
        </label>
        <label class="col-4" style="padding: 0px 3px;">
          <div class="client-list-modal__label">Apellido</div>
          <input class="client-list-modal__select" type="text" [(ngModel)]="filterLastName" />
        </label>
        <label class="col-4" style="padding: 0px 3px;">
          <div class="client-list-modal__label">Email</div>
          <input class="client-list-modal__select" type="text" [(ngModel)]="filterEmail" />
        </label>
      </div>

      <!-- Filter Buttons -->
      <div class="row">
        <div class="col-8"></div>
        <div class="col-4">
          <div class="d-flex align-items-center" style="gap: 10px;">
            <button class="btn btn-cancel w-100 py-1 px-2" (click)="clearFilters()">Borrar</button>
            <button class="btn btn-confirm w-100 py-1 px-2" (click)="onFilterChange()">Buscar</button>
          </div>
        </div>
      </div>
    </div>

<!-- Tabla -->
    <div class="client-list-modal__table-wrapper">
      <table class="client-list-modal__table">
        <thead class="client-list-modal__table-head">
          <tr class="client-list-modal__table-row">
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header">Nombre</th>
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header">Apellido</th>
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header">Email</th>
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header text-center">Seleccionar</th>
          </tr>
        </thead>
        <tbody class="client-list-modal__table-body">
          <tr class="client-list-modal__table-row" *ngFor="let client of clients">
            <td class="client-list-modal__table-cell">{{ client.first_name || '-' }}</td>
            <td class="client-list-modal__table-cell">{{ client.last_name || '-' }}</td>
            <td class="client-list-modal__table-cell">{{ client.email || '-'}}</td>
            <td class="client-list-modal__table-cell text-center">
              <input
                class="client-list-modal__table-cell-checkbox"
                type="checkbox"
                [checked]="selectedClientEmail === client.email"
                (change)="selectClient(client)"
              />
            </td>
          </tr>
          <tr class="client-list-modal__table-row client-list-modal__table-row--empty" *ngIf="clients.length === 0">
            <td colspan="4" class="client-list-modal__table-cell client-list-modal__table-cell--empty">No se encontraron clientes</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="client-list-modal__pagination">
      <span class="client-list-modal__pagination-info">
        {{ startItem }} - {{ endItem }} de {{ totalItems }}
      </span>

      <div class="client-list-modal__pagination-controls">
        <button
          class="client-list-modal__pagination-btn"
          (click)="previousPage()"
          [disabled]="currentPage === 1"
        >
          &lt;
        </button>
        <button
          class="client-list-modal__pagination-btn"
          (click)="nextPage()"
          [disabled]="currentPage >= lastPage"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
</div>
